
document.addEventListener("DOMContentLoaded", () => {
    // document.querySelectorAll(".copy_plate .copy-text").forEach(el => {
    //     if(!el){
    //         return false;
    //     }
    //     const tooltip = el.querySelector(".copy-tooltip");

    //     el.addEventListener("click", () => {
    //         const textToCopy = el.querySelector(".copy-text-content").getAttribute("data-copy");
    //         navigator.clipboard.writeText(textToCopy).then(() => {

    //             tooltip.classList.add("show");

    //             setTimeout(() => {
    //                 tooltip.classList.remove("show");
    //             }, 1500);
    //         }).catch(err => {
    //             console.error("Copy failed:", err);
    //         });
    //     });
    // });
    $('.copy-text-content').on('click',function(){
        const textToCopy = $(this).data('copy');
        navigator.clipboard.writeText(textToCopy).then(() => {
            const tooltip = $(this).siblings(".copy-tooltip");
            tooltip.addClass("show");
            setTimeout(() => {
                tooltip.removeClass("show");
            }, 1500);
        }).catch(err => {
            console.error("Copy failed:", err);
        });
    });
});